import { gql } from '@apollo/client';

export const FINANCIAL_PRODUCT_SEASONALITY_TEMPLATE_UPDATED = gql`
  subscription financialProductSeasonalityTemplateUpdated {
    financialProductSeasonalityTemplateUpdated {
      seasonalityTemplate {
        seasonalityTemplateId
        productId
        templateId
        default
      }
      orderNo
    }
  }
`;

export const FINANCIAL_PRODUCT_SEASONALITY_TEMPLATE_REMOVED = gql`
  subscription financialProductSeasonalityTemplateDeleted {
    financialProductSeasonalityTemplateDeleted {
      seasonalityTemplateId
    }
  }
`;

export const ALL_FINANCIAL_PRODUCT_SEASONALITY_TEMPLATES_REMOVED = gql`
  subscription allFinancialProductSeasonalityTemplatesDeleted {
    allFinancialProductSeasonalityTemplatesDeleted {
      headers {
        charismaUserId
        nbbCorrelationId
        userId
      }
    }
  }
`;
